import bezinga from "../assets/logos/bezinga.svg";
import finnhub from "../assets/logos/finnhub.svg";
import fool from "../assets/logos/fool.svg";
import globenewswire from "../assets/logos/globenewswire.svg";
import seekingAlpha from "../assets/logos/seekingAlpha.svg";
import investing from "../assets/logos/investing.svg";
import polygon from "../assets/logos/polygon.svg";
import wallSt from "../assets/logos/wallSt.svg";
import onlineInvestor from "../assets/logos/onlineInvestor.svg";
import etfChannel from "../assets/logos/etfChannel.svg";
import yahooFin from "../assets/logos/yahooFin.svg";
import marketWatch from "../assets/logos/marketWatch.svg";
import investorPlace from "../assets/logos/investorPlace.svg";
import guru from "../assets/logos/guru.svg";
import theFly from "../assets/logos/theFly.svg";
import talkMarkets from "../assets/logos/talkMarkets.svg";
import fintel from "../assets/logos/fintel.svg";
import dowJones from "../assets/logos/dowJones.svg";
import tipRanks from "../assets/logos/tipRanks.svg";
import accessWire from "../assets/logos/accessWire.svg";
import investorsbd from "../assets/logos/investorsbd.svg";
import wallStreetJournal from "../assets/logos/wallStreetJournal.svg";
import cnn from "../assets/logos/cnn.svg";
import investopedia from "../assets/logos/investopedia.svg";
import techcrunch from "../assets/logos/techcrunch.svg";
import thestreet from "../assets/logos/thestreet.svg";
import verdict from "../assets/logos/verdict.svg";
import retailinsight from "../assets/logos/retailinsight.svg";

export const NEWS_LOGOS: Record<string, string> = {
  "accessnewswire.com": accessWire,
  "benzinga.com": bezinga,
  "cnn.com": cnn,
  "ca.finance.yahoo.com": yahooFin,
  "dowjones.com": dowJones,
  "edition.cnn.com": cnn,
  "etfchannel.com": etfChannel,
  "finnhub.io": finnhub,
  "fintel.io": fintel,
  "finance.yahoo.com": yahooFin,
  "fool.com": fool,
  "globenewswire.com": globenewswire,
  "guru.com": guru,
  "investing.com": investing,
  "investors.com": investorsbd,
  "investopedia.com": investopedia,
  "investorplace.com": investorPlace,
  "marketwatch.com": marketWatch,
  "polygon.com": polygon,
  "retail-insight-network.com": retailinsight,
  "static2.finnhub.io": finnhub,
  "seekingalpha.com": seekingAlpha,
  "talkmarkets.com": talkMarkets,
  "thefly.com": theFly,
  "thestreet.com": thestreet,
  "theonlineinvestor.com": onlineInvestor,
  "tipranks.com": tipRanks,
  "techcrunch.com": techcrunch,
  "uk.finance.yahoo.com": yahooFin,
  "verdict.co.uk": verdict,
  "wsj.com": wallStreetJournal,
  "247wallst.com": wallSt,
};

export const NEWS_SOURCES: Record<string, string> = {
  "accessnewswire.com": "Access News Wire",
  "benzinga.com": "Benzinga",
  "cnn.com": "CNN",
  "ca.finance.yahoo.com": "Yahoo Finance",
  "clinicaltrialsarena.com": "Clinical Trials Arena",
  "dowjones.com": "Dow Jones",
  "edition.cnn.com": "CNN",
  "etfchannel.com": "ETF Channel",
  "finnhub.io": "Finnhub",
  "fintel.io": "Fintel",
  "finance.yahoo.com": "Yahoo Finance",
  "fool.com": "The Motley Fool",
  "globenewswire.com": "Globe News Wire",
  "guru.com": "Guru",
  "hospitalmanagement.net": "Hospital Management",
  "investing.com": "Investing",
  "investors.com": "Investor's Business Daily",
  "investopedia.com": "Investopedia",
  "investorplace.com": "Investor Place",
  "marketwatch.com": "Market Watch",
  "polygon.com": "Polygon",
  "pharmavoice.com": "Pharma Voice",
  "retail-insight-network.com": "Retail Insight Network",
  "static2.finnhub.io": "Finnhub",
  "seekingalpha.com": "Seeking Alpha",
  "talkmarkets.com": "Talk Markets",
  "thefly.com": "The Fly",
  "thestreet.com": "The Street",
  "theonlineinvestor.com": "The Online Investor",
  "tipranks.com": "TipRanks",
  "techcrunch.com": "Tech Crunch",
  "uk.finance.yahoo.com": "Yahoo Finance UK",
  "verdict.co.uk": "Verdict",
  "wsj.com": "Wall Street Journal",
  "247wallst.com": "24/7 Wall St.",
};
